<template>
	<Col class="flex-align-center">
		<Row class="flex-align-center width-100">
			<AnemicButton @click="goBack" class="back-button" width="25" height="25" fab x-small>
				<AppIcon name="back" />
			</AnemicButton>
			<h3 class="reg">Back</h3>
		</Row>
		<OnboardingFeatureDescriptionDialogContent
			@close="goBack"
			:workflowId="workflow.id"
			v-if="showEditFeatureDescription"
			class="feature-description-dialog"
		/>
		<SuggestCredentialsTypeDialogContent
			@close="goBack"
			v-on="$listeners"
			:workflow="workflow"
			v-else-if="showReassignConnectionsSuggestions"
		/>
	</Col>
</template>
<script>
import SuggestCredentialsTypeDialogContent from '@/components/dialogs/SuggestCredentialsTypeDialog/SuggestCredentialsTypeDialogContent.vue';
import OnboardingFeatureDescriptionDialogContent from '@/components/dialogs/OnboardingTextEditorDialog/OnboardingFeatureDescriptionDialogContent.vue';
export default {
	name: 'BeforeShareRecommendationPageContent',
	components: {
		SuggestCredentialsTypeDialogContent,
		OnboardingFeatureDescriptionDialogContent,
	},
	props: {
		workflow: { type: Object },
		showEditFeatureDescription: { type: Boolean },
		showReassignConnectionsSuggestions: { type: Boolean },
	},
	computed: {},
	methods: {
		goBack() {
			this.$emit('back');
		},
	},
};
</script>
<style scoped lang="scss">
.back-button {
	margin-right: 6px;
	border-radius: 6px;
	border: 1px solid var(--grey-background);
}
::v-deep {
	.dialog-content {
		width: 570px;
		height: 580px !important;
		padding: 8px 0px 0px 0px !important;
	}
	.suggestions-content-container {
		width: 580px;
		height: 560px !important;
		padding: 8px 0px 0px 0px !important;
	}
	.text-preview {
		margin-bottom: 6px !important;
	}
	.help-users {
		margin-bottom: 2px !important;
	}
	.feature-description-preview-title {
		margin-bottom: 6px !important;
	}
}
</style>
